ready(function () {
  handleTabbedAccordions();
});

/*
 * HANDLE TABBED ACCORDIONS
 */
let accordionPaused = false;
function _loadAccordionMedia(imageContainer, imagePlaceholder) {
  if (!imageContainer || !imagePlaceholder || imageContainer.innerHTML.trim().length === 0) return;

  imagePlaceholder.innerHTML = imageContainer.innerHTML;
  const image = imagePlaceholder.querySelector("img");
  if (image) {
    image.style.height = `${image.height}px`;
    image.style.scale = `${imageContainer.dataset.scale}`;
    image.style.top = `${imageContainer.dataset.offset}em`;
  }

  externalVideoObserver.observe(imagePlaceholder.querySelector('iframe[data-type="external_video"]'));
}

function handleTabbedAccordions() {
  const imageReduction = 0;
  const tabbedAccordionSections = document.querySelectorAll(".tabbed-accordion-section");
  tabbedAccordionSections.forEach(function (section) {
    if (!section.dataset.observerInitialized) {
      section.dataset.observerInitialized = "true";
      accordionObserver.observe(section);
    }
    const tabList = section.querySelector(".js--tabbed-accordion-tab-list");
    const tabbedAccordions = section.querySelectorAll(".tabbed-accordion-tab");

    // Begin: Play/pause button.
    section.querySelectorAll('[data-js="accordion-play-toggle"]').forEach((playButton) => {
      if (playButton && !playButton.dataset.initialized) {
        playButton.dataset.initialized = "true";

        playButton.addEventListener("click", function () {
          const activeTab = section.querySelector(".tabbed-accordion-tab.active");
          if (!activeTab) return;

          if (activeTab.classList.contains("autoplay")) {
            _stopAccordion(activeTab);
            _cancelAccordionProgressBar(activeTab);
          } else {
            activeTab.classList.add("autoplay");
            _playAccordion();
          }

          _updatePlayButton(activeTab);
        });
      }
    });
    // End: play/pause button.

    // Hide the tab list if there's only one tab.
    if (tabbedAccordions.length <= 1) {
      tabList.style.display = "none";
    }

    tabbedAccordions.forEach(function (tab, index) {
      // Get the tab heading to create a list.
      let title = tab.querySelector(".tabbed-accordion-tab-title");
      let tabId = title.dataset.id;
      let tabAutoplayEnabled = tab.dataset.autoplayEnabled;
      let tabAutoplayDelay = tab.dataset.autoplayDelay;

      // Autoplay the first tab if option is enabled.
      if (index == 0 && tab.hasAttribute("data-accordion") && tab.dataset.accordion == "true") {
        if (tabAutoplayEnabled == "true") {
          tab.classList.add("autoplay");
        }
      }

      // Show the first image.
      let imagePlaceholder = tab.querySelector('[data-image="tabbed-accordion-tab-image"]');
      let detailsImage = tab.querySelector("details:first-child");
      let imageContainer = null;
      if (detailsImage !== null) {
        imageContainer = detailsImage.querySelector(".js--tabbed-accordion-tab-image");
        _loadAccordionMedia(imageContainer, imagePlaceholder.querySelector(".image-placeholder"));
      }

      // Generate the tab menu.
      tabList.insertAdjacentHTML(
        "beforeend",
        `<li>
          <button type="button"
            data-target="${tabId}"${index === 0 ? ' class="active"' : ""}>
            ${title.innerText}
          </button>
        </li>`
      );

      // On page load, only show the first tab's content.
      if (index === 0) {
        tab.classList.add("active");
      }
      if (index === 0) {
        _updatePlayButton(tab);
      }

      // Work the details/summary elements as accordions, but
      // only if option is activated for this tab.
      if (tab.hasAttribute("data-accordion")) {
        if (window.matchMedia("(min-width: 1025px)").matches) {
          let details = tab.querySelectorAll("details");
          details.forEach(function (detail) {
            detail.addEventListener("toggle", function (event) {
              // Only run if accordion is open.
              if (!event.target.hasAttribute("open")) return;

              // Get all open accordions inside this tab.
              let opened = tab.querySelectorAll("details[open]");

              // Close open ones that aren't current accordion.
              for (let accordion of opened) {
                if (accordion === event.target) {
                  accordion.open = true;
                } else {
                  accordion.open = false;
                }
              }

              // Load the open details/summary image.
              let imageContainer = event.target.querySelector(".js--tabbed-accordion-tab-image");
              _loadAccordionMedia(imageContainer, imagePlaceholder.querySelector(".image-placeholder"));
            });
            // Stop autoplay.
            detail.addEventListener("click", function () {
              _stopAccordion(tab);
              _cancelAccordionProgressBar(tab);
              _updatePlayButton(tab);
            });
          });
        }
      }
    });

    // Toggle active tabs.
    tabList.querySelectorAll("button").forEach(function (button) {
      button.addEventListener("click", function (event) {
        let targetTabContent = button.dataset.target;
        tabList.querySelector("button.active").classList.remove("active");
        button.classList.add("active");
        section.querySelector(".tabbed-accordion-tab.active").classList.remove("active", "autoplay");
        section.querySelector(`.tabbed-accordion-tab[data-target="${targetTabContent}"]`).classList.add("active");
        section.querySelector(`.tabbed-accordion-tab[data-target="${targetTabContent}"] details:first-child`).open =
          true;
        if (section.querySelector(".tabbed-accordion-tab.active").dataset.autoplayEnabled == "true") {
          section.querySelector(".tabbed-accordion-tab.active").classList.add("autoplay");
          _playAccordion();

          const activeTab = section.querySelector(".tabbed-accordion-tab.active");
          _updatePlayButton(activeTab);
        }
        _resetExternalVideos();
      });
    });

    // Show scrolling indicator if tablist is longer that viewport,
    // and hide it once interacted with.
    if (tabList.scrollWidth > tabList.parentElement.clientWidth) {
      tabList.classList.add("indicator");
    }
    tabList.addEventListener("scroll", function (event) {
      tabList.classList.remove("indicator");
    });
  });

  document.querySelectorAll(".tabbed-accordion-section").forEach((section) => {
    const rect = section.getBoundingClientRect();
    const visible = rect.top < window.innerHeight * 0.5 && rect.bottom > window.innerHeight * 0.5;
    if (visible) {
      section.querySelectorAll(".tabbed-accordion-tab.autoplay").forEach(() => {
        _playAccordion();
      });
    }
  });
}
// Autoplay tabs - Cycle through the details for the current tab.
function _playAccordion() {
  document.querySelectorAll('[data-accordion="true"]').forEach(function (tab) {
    clearInterval(tab._accordionTimer);
  });

  if (accordionPaused) return;
  // Only one tab per section would have the active `.autoplay` class assigned. We
  // must loop through all the sections and play them.
  document.querySelectorAll('[data-accordion="true"].autoplay').forEach(function (tab) {
    const details = tab.querySelectorAll("details");
    let cycleDelay = Number.parseInt(tab.dataset.autoplayDelay);
    _animateAccordionProgressBar(tab, cycleDelay);

    if (details.length <= 1) return;
    tab.dataset.autoplayInitialized = "true";
    tab._accordionTimer = setInterval(function () {
      if (!tab.classList.contains("active") || !window.matchMedia("(min-width: 1025px)").matches) return;
      const activeIndex = Array.from(details).findIndex(function (detail) {
        return detail.open;
      });
      const nextIndex = activeIndex + 1 >= details.length ? 0 : activeIndex + 1;
      details[nextIndex].open = true;

      _animateAccordionProgressBar(tab, cycleDelay);
    }, cycleDelay);
  });
}
function _stopAccordion(tab) {
  clearInterval(tab._accordionTimer);
  tab.classList.remove("autoplay");
}

function _pauseAccordion() {
  accordionPaused = true;
  document.querySelectorAll('[data-accordion="true"]').forEach(function (tab) {
    clearInterval(tab._accordionTimer);
  });
  document.querySelectorAll('[data-accordion="true"].autoplay').forEach(function (tab) {
    _cancelAccordionProgressBar(tab);
  });
}

function _resumeAccordion() {
  accordionPaused = false;
  _playAccordion();
}

function _toggleAccordionPlayback() {
  if (accordionPaused) {
    _resumeAccordion();
  } else {
    _pauseAccordion();
  }
}

function _animateAccordionProgressBar(tab, delay) {
  let progressFill = tab.querySelector(".progress-fill");
  if (progressFill) {
    // Reset animation.
    progressFill.classList.remove("animate");
    void progressFill.offsetWidth;
    // Apply new duration.
    progressFill.style.animationDuration = `${delay}ms`;

    if (!accordionPaused) {
      progressFill.classList.add("animate");
    }
  }
}
function _cancelAccordionProgressBar(tab) {
  let progressFill = tab.querySelector(".progress-fill");
  if (progressFill) {
    progressFill.classList.remove("animate");
    void progressFill.offsetWidth;
  }
}
function _updatePlayButton(tab) {
  const isPlaying = tab.classList.contains("autoplay");
  tab.querySelectorAll('[data-js="accordion-play-toggle"]').forEach((button) => {
    button.setAttribute("aria-pressed", (!isPlaying).toString());
    button.querySelector("span").textContent = isPlaying ? "Pause" : "Play";
  });
}

/*
 * ACCORDION AUTOPLAY OBSERVER.
 */
const accordionObserver = createViewportObserver({
  threshold: 0.5,
  onEnter: (section) => {
    section.querySelectorAll(".tabbed-accordion-tab.autoplay").forEach((tab) => {
      _playAccordion();
      _updatePlayButton(tab);
    });
  },
  onLeave: (section) => {
    section.querySelectorAll(".tabbed-accordion-tab.autoplay").forEach((tab) => {
      clearInterval(tab._accordionTimer);
      _cancelAccordionProgressBar(tab);
    });
  },
});
